// this is used to override Material ui styles using theme
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: ['"Montserrat"', 'Open Sans'].join(','),
  },
  palette: {
    type: 'dark',
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        backgroundColor: 'black',
      },
    },
  },
});

export default theme;
